<template>
    <div class="form-floating mb-2 position-relative">
        <!-- Ícone dentro do campo -->
        <img class="position-absolute top-50 start-0 translate-middle-y ps-3" :src="iconSrc" alt="Ícone" width="40px"
            style="z-index: 9;">

        <input 
            inputmode="numeric" 
            :disabled="!isEditable" 
            :value="modelValue" type="tel"
            :class="['form-control ps-5', { 'error-border': errors?.length > 0 }]"
            :id="inputId" required
            @input="onInput" style="height: 66px; border-radius: .75rem;" :placeholder="placeholder" maxlength="10"
        >

        <label :for="inputId" class="ps-5">{{ label }}<span v-if="required" class="text-danger">*</span></label>
    </div>

<p v-if="errors && errors.length" class="text-danger error">{{ errors[0] }}</p>

</template>

<script>
export default {
    name: 'DateInputWithIcon',
    props: {
        modelValue: { type: String, required: true },
        errors: { type: Array, default: () => [] },
        isEditable: { type: Boolean, default: true },
        placeholder: { type: String, default: 'Data' },
        label: { type: String, default: 'Data' },
        inputId: { type: String, default: 'date_input' },
        iconSrc: { type: String, default: 'https://img.icons8.com/?size=100&id=85102&format=png&color=B0B2B3' },
        required: { type: Boolean, default: true },
    },
    emits: ['update:modelValue'],
    methods: {
        formatDate(value) {
            value = value.replace(/\D/g, '');
            if (value.length > 2) value = value.slice(0, 2) + '/' + value.slice(2);
            if (value.length > 5) value = value.slice(0, 5) + '/' + value.slice(5, 9);
            return value;
        },
        onInput(event) {
            const formatted = this.formatDate(event.target.value);
            this.$emit('update:modelValue', formatted);
        }
    }
}
</script>

<style scoped>
/* Borda de erro */
.error-border {
    border: 1px solid red !important;
    border-radius: 0.75rem !important;
}

/* Mensagem de erro */
.text-danger {
    width: 100%;
    text-align: left;
    padding: 5px;
}

/* Espaço para o ícone dentro do input */
.form-floating input {
    padding-left: 43px !important;
}

/* Ícone posicionado acima do input */
.form-floating img {
    z-index: 9;
}
</style>
